import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import IclinicPay from 'features/onlinePayment/containers/iclinic-pay';

const Root = () => (
  <Switch>
    <Route path="/pagamento" component={IclinicPay} />
    <Redirect to="/404/" />
  </Switch>
);

export default Root;
